import { Component, Vue, Watch } from 'vue-property-decorator'
import { isEmpty, debounce } from 'lodash'

@Component
export default class Filters extends Vue {
  // Filters
  search = null
  range = null
  startDate = null
  endDate = null

  // @ts-ignore
  @Watch('search')
  updateSearch = debounce(function(value) {
    this.$router.push({ query: Object.assign({}, this.$route.query, { search: value }) })
  }, 500)

  get hasFilters() {
    const query = this.$route.query
    return !(isEmpty(query) || Object.values(query).every((x) => (x === null || x === '')))
  }

  resetFilters() {
    this.$router.push({ query: {} })
  }

  updateDates(datas) {
    const str = Object.values(datas).toString()
    this.range = str.replace(/,\s*$/, '')
    this.$router.push({ query: Object.assign({}, this.$route.query, { range: this.range }) })
  }
}

